import NotFound from './not-found';
import ProductCarousel from './elements/product-carousel';
import Catalog from './catalog';
import { useContext, useState } from 'react';
import { CategoriesContext } from '../../../App';
import { useNewProducts } from '../../../util/use-category-products';

export enum ViewMode {
    List,
    Tile,
}

function NewIekCatalogWrapper() {
    const { currentCategory } = useContext(CategoriesContext);
    const [viewMode, setViewMode] = useState(ViewMode.List);
    const newProducts = useNewProducts(currentCategory);
    if (!currentCategory) {
        return <NotFound>Раздел не найден</NotFound>;
    }
    return (
        <div className={'catalog-content' + (viewMode === ViewMode.List ? ' catalog-content--list' : '')}>
            <Catalog viewMode={viewMode} setViewMode={setViewMode} />
            {newProducts.length > 0 && (
                <div className="category-new-products">
                    <div className="products-slider">
                        <h2 className="products-slider__title">Новое в категории</h2>
                        <ProductCarousel products={newProducts} />
                    </div>
                </div>
            )}
            {currentCategory.seoText && (
                <div
                    className="category-description text-content"
                    dangerouslySetInnerHTML={{ __html: currentCategory.seoText }}
                />
            )}
        </div>
    );
}

export default NewIekCatalogWrapper;
